import React from 'react'

const IsLoading = () => {
  return (
    <div  className='loader'>
    </div>
  )
}

export default IsLoading
